
 import {
    FETCH_LANGUAGE_REQUEST,
    FETCH_LANGUAGE_SUCCESS,
    FETCH_LANGUAGE_FAILURE,
    SET_SELECTED_LANGUAGE,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchLanguage = () => async (dispatch) => {
    dispatch({ type: FETCH_LANGUAGE_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetLanguagesDDL`); 
    //   console.log("langresponse", response);

      let langList =response.data.responseData.map((val)=>{   
          return{
              value:val.id,
              label:val.name,
            }
        })
      dispatch({
        type: FETCH_LANGUAGE_SUCCESS,
        payload: langList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_LANGUAGE_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectLang = (langId) => ({
    type: SET_SELECTED_LANGUAGE,
    payload: langId,
  });
  